import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import LoginModal from "../../Pages/Users/LoginModal";
import LanguageModal from "../Common/Model/LanguageModal";
import "../Utility/echo"; // correct path to echo.js file
import NotificationBell from "../Utility/NotificationBell";

function HeaderHost() {
  const location = useLocation();
  const [loginOpen, setLoginOpen] = useState(false);
  const [languageOpen, setLanguageOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [headerLogo, setHeaderLogo] = useState(null);

  const [loginType, setLoginType] = useState(1);
  const [user, setUser] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    // Close mobile menu whenever route changes
    document.body.classList.remove("show-menu");
    setIsOpen(false);
  }, [location.pathname]);

  const [unreadCount, setUnreadCount] = useState(0);
  const API_BASE = process.env.REACT_APP_API_BASE;
  const token = localStorage.getItem("authToken");

  const fetchUnreadCount = useCallback(async () => {
    try {
      if (!token) return;

      const res = await axios.get(`${API_BASE}/host/chat-users`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const chats = res.data?.data || [];
      const totalUnread = chats.reduce(
        (sum, chat) => sum + (Number(chat.unread_count) || 0),
        0
      );
      setUnreadCount(totalUnread);
    } catch (err) {
      console.error("Error fetching unread count:", err);
    }
  }, [API_BASE, token]);

  useEffect(() => {
    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 5000);
    return () => clearInterval(interval);
  }, [fetchUnreadCount]);

  useEffect(() => {
    const handleUnreadChange = () => fetchUnreadCount();
    window.addEventListener("unreadCountUpdated", handleUnreadChange);
    return () =>
      window.removeEventListener("unreadCountUpdated", handleUnreadChange);
  }, [fetchUnreadCount]);

  useEffect(() => {
    const closeOnClickOutside = () => setIsOpen(false);
    if (isOpen) {
      document.addEventListener("click", closeOnClickOutside);
    }
    return () => document.removeEventListener("click", closeOnClickOutside);
  }, [isOpen]);

  const fetchHeaderLogo = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/getWebSettingsByCategory/header_logo/headerlogo`
      );

      if (res.data && res.data.status && res.data.data) {
        const fileName = res.data.data.title; // get last part (image.png)
        const fullPath = res.data.base_url + fileName;
        setHeaderLogo(fullPath);
      }
    } catch (err) {
      console.error("Error fetching header logo:", err);
    }
  };
  useEffect(() => {
    fetchHeaderLogo();
  }, []);
  useEffect(() => {
    const header = document.getElementById("fixedds");
    if (!header) return;

    // distance from top where sticky should start
    const stickyPoint = header.offsetTop;

    const handleScroll = () => {
      // only toggle once the scroll is beyond the header
      if (window.pageYOffset > stickyPoint + 5) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Check mobile resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Toggle show-menu on body
  const toggleMobileMenu = (e) => {
    e.stopPropagation();
    document.body.classList.toggle("show-menu");
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("authToken");
    localStorage.removeItem("expiry");
    localStorage.removeItem("hostData");
    localStorage.removeItem("userWishlist");
    localStorage.removeItem("selectedCurrency");
    setUser(null);
    setIsOpen(false);
    toast.success("You have successfully logged out.");
    navigate("/");
  };

  const handleSwitchToTraveler = async () => {
    const storedToken = localStorage.getItem("authToken");

    if (!storedToken) {
      // Not logged in → force login modal
      setLoginType(1);
      setLoginOpen(true);
      return;
    }

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/host/switch-to-traveller`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      if (res.data && !res.data.error) {
        // ✅ update token & user in localStorage
        if (res.data.token) {
          localStorage.setItem("authToken", res.data.token);
        }
        if (res.data.user) {
          localStorage.setItem("user", JSON.stringify(res.data.user));
          setUser(res.data.user);
        }

        // ✅ redirect to profile
        navigate("/");
      } else {
        toast.error(
          res.data.message || "Something went wrong. Please try again."
        );
      }
    } catch (err) {
      console.error("Error switching to traveller:", err);
      toast.error("Failed to switch to traveller. Please try again.");
    }
  };

  const loadUserData = () => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    } else {
      setUser(null);
    }
  };

  // 🔥 initial load + listen for changes
  useEffect(() => {
    loadUserData();
    window.addEventListener("userDataUpdated", loadUserData);
    return () => window.removeEventListener("userDataUpdated", loadUserData);
  }, [location.pathname]);

  return (
    <>
      <header
        id="fixedds"
        className={isSticky ? "others_pgs sticky" : "others_pgs"}
      >
        <div className="container">
          <nav>
            <div className="line">
              {isMobile && (
                <p className="nav-text" onClick={toggleMobileMenu}>
                  <span></span>
                </p>
              )}
              <div className="lgo_mg">
                {Number(user?.host_profile) === 1 ? (
                  <Link to="/">
                    <img
                      src={headerLogo || "/images/oth_pg_logo.png"}
                      alt="Logo"
                    />
                  </Link>
                ) : (
                  <Link to="/">
                    <img
                      src={headerLogo || "/images/oth_pg_logo.png"}
                      alt="Logo"
                    />
                  </Link>
                )}

                <div className="bell-wrapper mb_view_show" onClick={() => navigate("/account-notification")}>
                  <NotificationBell user={user} />
                </div>
              </div>

              {Number(user?.user_type) === 2 &&
                Number(user?.host_profile) === 1 && (
                  <div className="sort_form_arae host_header_dashboard ">
                    <div className="nav_linksss">
                      <ul>
                        <li>
                          <NavLink
                            to={"/dashboard"}
                            className={({ isActive }) =>
                              isActive ? "actat" : ""
                            }
                          >
                            Today
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to={"/calender"}
                            className={({ isActive }) =>
                              isActive ? "actat" : ""
                            }
                          >
                            Calender
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to={"/listing"}
                            className={({ isActive }) =>
                              isActive ? "actat" : ""
                            }
                          >
                            Listings
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to={"/message"}
                            className={({ isActive }) =>
                              isActive ? "actat" : ""
                            }
                          >
                            Messages{" "}
                            {unreadCount > 0 && (
                              <span className="usr_count">
                                {unreadCount > 9 ? "9+" : unreadCount}
                              </span>
                            )}
                          </NavLink>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}

              {/* Top Nav */}

              <div className="top-nav s-12 l-12">
                <ul className="lgnnss">
                  {Number(user?.user_type) === 2 &&
                    Number(user?.signup_complete_status) === 1 && (
                      <>
                        <li>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleSwitchToTraveler();
                            }}
                          >
                            <i
                              class="fa fa-user-secret mb_view_show"
                              aria-hidden="true"
                            ></i>{" "}
                            Switch to Experiences
                          </a>
                        </li>
                        <li
                          className="bell-wrapper mb_view_hide"
                          onClick={() => navigate("/account-notification")}
                        >
                          {/* <img
                            src="/images/bell_icons.png"
                            alt="Notification"
                          />

                          <span className="usr_count bell_count">
                            {notificationCount > 9 ? "9+" : notificationCount}
                          </span> */}
                          <NotificationBell user={user} />
                        </li>
                      </>
                    )}

                  {Number(user?.user_type) === 2 &&
                    Number(user?.signup_complete_status) === 1 &&
                    (user ? (
                      <li>
                        <span className="namess">
                          <span
                            className="usr_mgs"
                            onClick={(e) => {
                              e.stopPropagation();
                              setIsOpen(!isOpen);
                            }}
                          >
                            <img
                              src={
                                user?.profile_image
                                  ? `${
                                      user?.base_url
                                        ? user.base_url
                                        : "https://admin.weyfarin.com"
                                    }/${user.profile_image.replace(/^\//, "")}`
                                  : "/images/user_dh.png"
                              }
                              alt={user?.first_name || "User"}
                            />
                          </span>
                          <span className="mb_view_show">
                            {user?.first_name} {user?.last_name}
                          </span>
                        </span>
                      </li>
                    ) : (
                      <li className="br_iconns mb_view_hide">
                        <a
                          className="bntssd"
                          onClick={() => setLanguageOpen(true)}
                        >
                          <img src="/images/language.svg" alt="language" />
                        </a>
                      </li>
                    ))}

                  <div
                    className={`scope ${isOpen ? "active" : ""}`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <ul>
                      <li>
                        <Link to={"/account-setting"}>
                          <img
                            src="/images/setting_ic.png"
                            alt=""
                            className="iconss"
                          />{" "}
                          Account Setting
                        </Link>
                      </li>

                      <li>
                        <Link to={"/account-notification"}>
                          <img
                            src="/images/ac_setting_ic5.png"
                            alt=""
                            className="iconss"
                          />{" "}
                          Notification
                        </Link>
                      </li>

                      <li>
                        <Link to={"/payment"}>
                          <img
                            src="/images/ac_setting_ic6.png"
                            alt=""
                            className="iconss"
                          />{" "}
                          Payments
                        </Link>
                      </li>

                      <li>
                        <a onClick={() => setLanguageOpen(true)}>
                          <img
                            src="/images/language.svg"
                            className="ic_other"
                            alt="Language"
                          />{" "}
                          Currency
                        </a>
                      </li>

                      <li>
                        <Link to={"help-and-faq"}>
                          <i className="fa fa-question-circle-o"></i> Help
                          Center
                        </Link>
                      </li>
                      <li>
                        <Link to={"/listing"}>
                          <i className="fa fa-align-left"></i> Listing
                        </Link>
                      </li>

                      <li>
                        {user ? (
                          <a
                            href="javascript:void(0)"
                            onClick={(e) => {
                              e.preventDefault();
                              handleLogout();
                            }}
                          >
                            <i
                              className="fa fa-sign-out"
                              aria-hidden="true"
                            ></i>{" "}
                            Logout
                          </a>
                        ) : (
                          <a
                            onClick={(e) => {
                              e.preventDefault();
                              setIsOpen(false);
                              setLoginOpen(true);
                            }}
                          >
                            Log in or sign up
                          </a>
                        )}
                      </li>
                    </ul>
                  </div>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </header>

      <LoginModal
        isOpen={loginOpen}
        onClose={() => setLoginOpen(false)}
        userType={loginType}
      />
      <LanguageModal
        isOpen={languageOpen}
        onClose={() => setLanguageOpen(false)}
      />
    </>
  );
}

export default HeaderHost;
